import RequestDemoButton from '../components/RequestDemoButton/RequestDemoButton';
import { stockAssets } from '../config/stockAssets';
import { concertVenueSections } from '../data/concertVenues';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './ConcertVenuesPage.module.css';

function ConcertVenuesPage() {
  usePageTitle('Concert Venues');

  return (
    <>
      <section className={styles.hero}>
        <div className={`container ${styles.heroGrid}`}>
          <div>
            <div className={styles.heroMeta}>
              <span className={styles.comingSoon}>Feature Coming Soon</span>
            </div>
            <span className="sectionLabel">Solutions</span>
            <h1 className={styles.title}>Concert Venues</h1>
            <p className={styles.lead}>
              ONI brings in-seat ordering to live music — starting with VIP, club, and reserved seating
              in premium areas where fans have an assigned location.
            </p>
          </div>
          <img
            src={stockAssets.concertVenue}
            alt="Outdoor amphitheater at twilight with a packed crowd under the canopy"
            className={styles.heroImage}
            loading="eager"
          />
        </div>
      </section>

      {concertVenueSections.map((section, index) => (
        <section
          key={section.label}
          className={`section ${index % 2 === 0 ? styles.sectionAlt : styles.section}`}
        >
          <div className={`container ${styles.sectionGrid}`}>
            <div>
              <span className="sectionLabel">{section.label}</span>
              <h2 className="sectionTitle">{section.title}</h2>
              <p className="sectionSubtitle">{section.subtitle}</p>
              <p className={styles.body}>{section.body}</p>
            </div>

            <div className={styles.details}>
              <div className={styles.scopeBlock}>
                <h3 className={styles.scopeTitle}>In scope</h3>
                <ul className={styles.scopeList}>
                  {section.inScope.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>

              {section.outOfScope && (
                <div className={styles.scopeBlock}>
                  <h3 className={styles.scopeTitle}>Not in scope</h3>
                  <ul className={`${styles.scopeList} ${styles.outOfScope}`}>
                    {section.outOfScope.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className={styles.benefitsBlock}>
                <h3 className={styles.scopeTitle}>For venue operators</h3>
                <ul className={styles.benefitsList}>
                  {section.benefits.map((benefit) => (
                    <li key={benefit}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className={styles.bottomCta}>
        <div className={`container ${styles.bottomCtaInner}`}>
          <h2>Interested in concert venue ordering?</h2>
          <p>
            Request a demo and we&apos;ll reach out when concert venue support launches.
          </p>
          <RequestDemoButton size="lg" />
        </div>
      </section>
    </>
  );
}

export default ConcertVenuesPage;
